export default {
    namespaced: true,
    state: () => ({
        ThongTinCapThe: {
            IdNhanVien: null,
            IdThe: null,
            DanhSachCong: null,
        },
        ThongTinHuyCapThe: {
            IdThe: null,
            IdNhanVien: null,
            LyDo: null,
        },
        DanhSachCongKiemSoat: [],
        LocBaoCao: {
            TuNgay: new Date(),
            DenNgay: new Date(),
        },
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
        Reset_ThongTinCapThe: (state) => {
            state.ThongTinCapThe = {
                IdNhanVien: null,
                IdThe: null,
                DanhSachCong: null,
            };
        },
        Reset_ThongTinHuyCapThe: (state) => {
            state.ThongTinHuyCapThe = {
                IdThe: null,
                IdNhanVien: null,
                LyDo: null,
            };
        },
    },

    actions: {
        LayDanhSachLichSuCapThe(store) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.LichSuCapThe")
                        ).Post({
                            loadOptions,
                            args: {
                                TuNgay: store.state.LocBaoCao.TuNgay,
                                DenNgay: store.state.LocBaoCao.DenNgay,
                            },
                        });

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                "IdThe" || null,
                async (key) => {
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachTheKiemSoat")
                        ).Post({
                            filter: ["IdThe", "=", key],
                        });
                        if (resp.StatusCode === 200) {
                            let data =
                                (resp.Data.data?.data || []).length > 0
                                    ? resp.Data.data.data[0]
                                    : {};
                            return data;
                        } else {
                            return {};
                        }
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    }
                }
            );
            return load;
        },

        async CapTheChoNhanVien(store) {
            try {
                let dataPost = {
                    IdNhanVien: store.state.ThongTinCapThe.IdNhanVien,
                    IdThe: store.state.ThongTinCapThe.IdThe,
                    DanhSachCong: store.state.ThongTinCapThe.DanhSachCong,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapThe")
                ).Post(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async KiemTraCapTheChoNhanVien(
            store,
            { IsKiemTraNhanVien, IsKiemTraThe }
        ) {
            try {
                let dataGet = {
                    IdNhanVien: IsKiemTraNhanVien
                        ? store.state.ThongTinCapThe.IdNhanVien
                        : 0,
                    IdThe: IsKiemTraThe ? store.state.ThongTinCapThe.IdThe : 0,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.KiemTraThongTinCapThe"),
                    dataGet
                ).Get(dataGet);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async LayDanhSachCongKiemSoat(store) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.DanhSachCongKiemSoat")
                ).Get();
                if (rs.Data.status) {
                    store.state.DanhSachCongKiemSoat = (rs.Data.data || []).map(
                        (item) => {
                            return {
                                IdCongKiemSoat: item,
                            };
                        }
                    );
                }
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async HuyCapThe(store) {
            try {
                let dataPost = {
                    IdThe: store.state.ThongTinHuyCapThe.IdThe || 0,
                    IdNhanVien: store.state.ThongTinHuyCapThe.IdNhanVien || 0,
                    LyDo: store.state.ThongTinHuyCapThe.LyDo,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.HuyCapThe")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
    },
};
